import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import pageHeadingStyles from "../../../styles/PageHeader.module.scss";
import styles from "./styles.module.scss";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import useMccStore from "../../../stores/mcc";
import useUserStore from "../../../stores/user";
import Plus from "../../../assets/svg/icons/common/Plus";
import Download from "../../../assets/svg/icons/common/Download";
import { ExportMccList } from "../../../../api";

const Header = () => {
  const [searchValue, setSearchValue] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const setSearchFilters = useMccStore((state) => state.setSearchFilters);
  const searchFilters = useMccStore((state) => state.searchFilters);
  const setIsAddMCCModalOpen = useMccStore((state) => state.setIsAddMCCModalOpen);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);
  // Matches the server-side gate on /mcc/export, which is the same
  // isPaymentCloudAdmin() check the rest of the MCC endpoints use.
  const canExport = useUserStore((state) => state.isPCAdmin);

  const timerRef = useRef(null);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
    setSelectedMcc([]);
  };

  const handleAddCodes = () => {
    setIsAddMCCModalOpen(true);
  };

  // Exports every row the current filters match, not just the visible page.
  const handleExport = async () => {
    setIsExporting(true);
    try {
      const response = await ExportMccList(searchFilters);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "mcc-codes.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("CSV downloaded");
    } catch (error) {
      // responseType is "blob", so a JSON refusal (permission, server error)
      // arrives as a Blob and has to be read back out to reach the user.
      let message = null;
      try {
        const data = error?.response?.data;
        const payload = data instanceof Blob ? JSON.parse(await data.text()) : data;
        message = payload?.message || null;
      } catch {
        message = null;
      }
      toast.error(message || "Failed to export MCC codes");
    }
    setIsExporting(false);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setSearchFilters({
        ...searchFilters,
        search: searchValue
      });
    }, 300);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [searchValue]);

  return (
    <>
      <div className={styles.mobile_header}>
        <div className={styles.mobile_search_wrapper}>
          <SearchInput
            searchValue={searchValue}
            onChange={handleChange}
            className={styles.mobile_search_input}
          />
        </div>
        {canExport && (
          <ButtonIcon
            bgColor="#EDEDF4"
            onClick={handleExport}
            disabled={isExporting}
            className={styles.mobile_add_button}
          >
            <Download />
          </ButtonIcon>
        )}
        <ButtonIcon
          bgColor="#4C70EF"
          textColor="#FFF"
          onClick={handleAddCodes}
          className={styles.mobile_add_button}
        >
          <Plus />
        </ButtonIcon>
      </div>
      <div className={`${pageHeadingStyles.page_heading} ${pageHeadingStyles.column}`}>
        <div className={styles.title_row}>
          <div className={pageHeadingStyles.title_contents}>
            <p>MCC Codes</p>
          </div>
          <div className={styles.right_side}>
            {canExport && (
              <ButtonIcon
                bgColor="#EDEDF4"
                onClick={handleExport}
                disabled={isExporting}
              >
                <Download />
                <span>{isExporting ? "Exporting..." : "Export"}</span>
              </ButtonIcon>
            )}
            <ButtonIcon bgColor="#4C70EF" textColor="#FFF" onClick={handleAddCodes}>
              <Plus />
              <span>Add Code</span>
            </ButtonIcon>
          </div>
        </div>
        <div className={styles.search_row}>
          <SearchInput searchValue={searchValue} onChange={handleChange} />
        </div>
      </div>
    </>
  );
};

export default Header;
